module.exports = __webpack_public_path__ + "assets/3163a947a94e761724b264b1987ccae4-DSC_0787.jpg";